(function() {
  let cachedPickupInventory = null;
  let cachedProductHandle = null;
  let cachedVariants = null;
  let inventoryPromise = null;

  function getProductHandle() {
    return document.querySelector('meta[name="product-handle"]')?.content
      || window.location.pathname.split('/products/')[1]?.split('?')[0];
  }

  function getSelectedVariantId(pickupAvailability = null) {
  const pickup =
    pickupAvailability ||
    document.querySelector('pickup-availability[form]');

  const formId = pickup?.getAttribute('form');

  if (formId) {
    const form =
      document.getElementById(formId) ||
      document.forms[formId];

    const variantField =
      form?.querySelector('[name="id"]:not([disabled])') ||
      form?.querySelector('[name="id"]');

    if (variantField?.value) {
      return String(variantField.value);
    }
  }

  const urlVariantId = new URL(
    window.location.href
  ).searchParams.get('variant');

  if (urlVariantId) {
    return String(urlVariantId);
  }

  if (pickup?.dataset.initialVariantId) {
    return String(pickup.dataset.initialVariantId);
  }

  const firstVariantId = Object.keys(
    window.variantStoreStocks || {}
  )[0];

    return firstVariantId || null;
}

  function getCurrentLang() {
    return document.documentElement.lang?.toLowerCase().startsWith('en') ? 'en' : 'fr';
  }

  function isPopupLocation(name) {
    const upper = (name || '').toUpperCase();
    return upper.includes('POP');
  }

  function isCoffretProduct(productHandle) {
    const handle = (productHandle || '').toLowerCase();
    return handle.includes('coffret') || handle.includes('ensemble');
  }

  function hasNegativeInventory(pickUpInventory) {
    return (pickUpInventory || []).some(location => Number(location.quantity) < 0);
  }

  function hasMultipleVariants(variants) {
    return (variants || []).length > 1;
  }

  function getDrawerList() {
    return document.querySelector('.pickup-drawer .athena-pickup-list');
  }

  function hideDrawerContentImmediately() {
    const ul = getDrawerList();
    if (!ul) return;
    ul.style.visibility = 'hidden';
  }

  function showDrawerContent() {
    const ul = getDrawerList();
    if (!ul) return;
    ul.style.visibility = '';
  }

  function getAvailabilityText(locationName, isAvailable) {
    const t = window.themeStrings || {};

    if (!isAvailable) {
      return t.pickupUnavailable || '';
    }

    const upper = (locationName || '').toUpperCase();

    if (upper.includes('ENTREPÔT') || upper.includes('ENTREPOT')) {
      return t.deliveryOrPickupMailChamplain || '';
    }

    if (upper.includes('MAIL CHAMPLAIN')) {
      return t.deliveryOrPickup || '';
    }

    if (upper.includes('CENTRE EATON') || upper.includes('PROMENADES ST-BRUNO')) {
      return t.pickupOnly || '';
    }

    return t.pickupAvailable || '';
  }

  function renderPickupLocations(
    ul,
    pickUpInventory,
    productHandle,
    hideQuantities = false
  ) {
    const isCoffret = isCoffretProduct(productHandle);

    ul.innerHTML = '';

    pickUpInventory.forEach(location => {
      if (isPopupLocation(location.location)) return;

      const isSteFoy = location.location.toUpperCase().includes('STE-FOY');
      const isAvailable = isCoffret || Number(location.quantity) > 0;
      const showStatusText = !isSteFoy;
      const availabilityText = getAvailabilityText(
        location.location,
        isAvailable
      );

      const li = document.createElement('li');
      li.className = 'pickup-availability-list-item';

      const iconSvg = isAvailable
        ? `<svg role="presentation" focusable="false" stroke-width="2" width="18" height="18" class="text-success icon icon-success" viewBox="0 0 18 18"><path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path><path d="M5 8.8L7.62937 11.6L13 6" stroke="#ffffff" fill="none"></path></svg>`
        : `<svg role="presentation" focusable="false" width="18" height="18" class="text-error icon icon-error" viewBox="0 0 18 18"><path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path><path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path></svg>`;

      li.innerHTML = `
        ${iconSvg}
        <span class="pickup-availability-list-content">
          <span class="pickup-availability-list-text">
            <span class="pickup-availability-list-location">${location.location}</span>
            ${
              showStatusText
                ? `<span class="pickup-availability-list-status">${availabilityText}</span>`
                : ''
            }
          </span>
          ${
            !hideQuantities
              ? `<span class="athena-qty pickup-availability-list-qty">(${location.quantity})</span>`
              : ''
          }
        </span>
      `;

      ul.appendChild(li);
    });
  }

function getSelectedVariantStoreInventory() {
  const variantId = getSelectedVariantId();

  if (!variantId || !window.variantStoreStocks || !window.variantStoreStocks[variantId]) {
    return null;
  }

  const stocks = window.variantStoreStocks[variantId];

  const requiredValues = [
    stocks.stock_entrepot,
    stocks.stock_mail_champlain,
    stocks.stock_centre_eaton,
    stocks.stock_promenades_st_bruno
  ];

  const hasIncompleteData = requiredValues.some(value => value === null || value === undefined);

  if (hasIncompleteData) {
    return null;
  }

  return [
    {
      location: 'ENTREPÔT',
      quantity: Number(stocks.stock_entrepot)
    },
    {
      location: 'MAIL CHAMPLAIN',
      quantity: Number(stocks.stock_mail_champlain)
    },
    {
      location: 'CENTRE EATON',
      quantity: Number(stocks.stock_centre_eaton)
    },
    {
      location: 'PROMENADES ST-BRUNO',
      quantity: Number(stocks.stock_promenades_st_bruno)
    }
  ];
}

function renderFromMetafieldsIfAvailable(productHandle) {
  const metafieldInventory = getSelectedVariantStoreInventory();

  if (!metafieldInventory) {
    return false;
  }

  const ul = getDrawerList();

  if (ul) {
    renderPickupLocations(ul, metafieldInventory, productHandle, false);
    showDrawerContent();
  }

  updateShippingNoticeVisibility(metafieldInventory);

  return true;
}
  function renderFromInventory(productHandle, pickUpInventory, variants) {
    const ul = getDrawerList();
    if (!ul) return;
    // Cacher le bouton pour les produits avec variantes : 
    // const hideQuantities = hasNegativeInventory(pickUpInventory) || hasMultipleVariants(variants);
    // Ne plus cacher le bouton :
    const hideQuantities = hasNegativeInventory(pickUpInventory) || hasMultipleVariants(variants);
    renderPickupLocations(ul, pickUpInventory, productHandle, hideQuantities);

    showDrawerContent();
  }
//Liste des jours fériés. À MODIFIER.
    const holidays = [
  // ===== 2026 =====
  '2026-01-01',
  '2026-04-03', // Vendredi saint
  '2026-04-06', // Lundi de Pâques
  '2026-05-18', // Patriotes
  '2026-06-24',
  '2026-07-01',
  '2026-09-07',
  '2026-10-12',
  '2026-12-25',

  // ===== 2027 =====
  '2027-01-01',
  '2027-03-26',
  '2027-03-29',
  '2027-05-24',
  '2027-06-24',
  '2027-07-01',
  '2027-09-06',
  '2027-10-11',
  '2027-12-25',

  // ===== 2028 =====
  '2028-01-01',
  '2028-04-14',
  '2028-04-17',
  '2028-05-22',
  '2028-06-24',
  '2028-07-01',
  '2028-09-04',
  '2028-10-09',
  '2028-12-25',

  // ===== 2029 =====
  '2029-01-01',
  '2029-03-30',
  '2029-04-02',
  '2029-05-21',
  '2029-06-24',
  '2029-07-02', // 1er juillet tombe dimanche → reporté
  '2029-09-03',
  '2029-10-08',
  '2029-12-25',

  // ===== 2030 =====
  '2030-01-01',
  '2030-04-19',
  '2030-04-22',
  '2030-05-20',
  '2030-06-24',
  '2030-07-01',
  '2030-09-02',
  '2030-10-14',
  '2030-12-25',


  // ===== 2031 =====
  '2031-01-01',
  '2031-04-11', // Vendredi saint
  '2031-04-14', // Lundi de Pâques
  '2031-05-19', // Patriotes
  '2031-06-24',
  '2031-07-01',
  '2031-09-01',
  '2031-10-13',
  '2031-12-25',

  // ===== 2032 =====
  '2032-01-01',
  '2032-03-26',
  '2032-03-29',
  '2032-05-24',
  '2032-06-24',
  '2032-07-01',
  '2032-09-06',
  '2032-10-11',
  '2032-12-25',

  // ===== 2033 =====
  '2033-01-01',
  '2033-04-15',
  '2033-04-18',
  '2033-05-23',
  '2033-06-24',
  '2033-07-01',
  '2033-09-05',
  '2033-10-10',
  '2033-12-25',

  // ===== 2034 =====
  '2034-01-01',
  '2034-04-07',
  '2034-04-10',
  '2034-05-22',
  '2034-06-24',
  '2034-07-01',
  '2034-09-04',
  '2034-10-09',
  '2034-12-25',

  // ===== 2035 =====
  '2035-01-01',
  '2035-03-23',
  '2035-03-26',
  '2035-05-21',
  '2035-06-24',
  '2035-07-02', // 1er juillet tombe dimanche → reporté
  '2035-09-03',
  '2035-10-08',
  '2035-12-25',

  // ===== 2036 =====
  '2036-01-01',
  '2036-04-11',
  '2036-04-14',
  '2036-05-19',
  '2036-06-24',
  '2036-07-01',
  '2036-09-01',
  '2036-10-13',
  '2036-12-25',
];

function formatDateLocal(date) {
  return date.getFullYear() + '-' +
    String(date.getMonth() + 1).padStart(2, '0') + '-' +
    String(date.getDate()).padStart(2, '0');
}

function addBusinessDays(startDate, businessDays) {
  const result = new Date(startDate);
  let added = 0;

  const holidaySet = new Set(holidays);

  while (added < businessDays) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();

    const isWeekend = (day === 0 || day === 6);
    const isHoliday = holidaySet.has(formatDateLocal(result));

    if (!isWeekend && !isHoliday) {
      added += 1;
    }
  }

  return result;
}

  function formatArrivalDate(date) {
  const lang = getCurrentLang();

  return new Intl.DateTimeFormat(lang === 'en' ? 'en-CA' : 'fr-CA', {
    day: 'numeric',
    month: 'long'
  }).format(date);
}

/*function updateShippingNoticeVisibility(pickUpInventory) {
  const notice = document.getElementById('shipping-notice-48h');
  const dateEl = document.getElementById('shipping-arrival-date');

  if (!notice) return;

  const hasWarehouseAvailability = (pickUpInventory || []).some(location => {
    const upper = (location.location || '').toUpperCase();
    const isRelevant = upper.includes('ENTREPÔT') || upper.includes('ENTREPOT') || upper.includes('MAIL CHAMPLAIN');
    return isRelevant && Number(location.quantity) > 0;
  });
  const fullTextEl = document.getElementById('shipping-arrival-full-text');
  if (dateEl) {
    const arrivalDate = addBusinessDays(new Date(), 3);
    const formattedDate = formatArrivalDate(arrivalDate);
    dateEl.textContent = formattedDate;
    if (fullTextEl) {
    const t = window.themeStrings || {};
    fullTextEl.textContent = `${t.arrivesBefore || ''} `;
    }
  }
  notice.style.display = hasWarehouseAvailability ? '' : 'none';
}*/
function updateShippingNoticeVisibility() {
  const notice = document.getElementById('shipping-notice-48h');
  if (!notice) return;

  const stocks = (window.variantStoreStocks || {})[getSelectedVariantId()] || {};
  const hasWarehouseAvailability =
    Number(stocks.stock_mail_champlain) > 0 || Number(stocks.stock_entrepot) > 0;

  const dateEl = document.getElementById('shipping-arrival-date');
  if (dateEl) {
    const formatted = formatArrivalDate(addBusinessDays(new Date(), 3));
    if (dateEl.textContent !== formatted) dateEl.textContent = formatted;
  }
  const fullTextEl = document.getElementById('shipping-arrival-full-text');
  if (fullTextEl) {
    const t = window.themeStrings || {};
    const txt = `${t.arrivesBefore || ''} `;
    if (fullTextEl.textContent !== txt) fullTextEl.textContent = txt;
  }

  const display = hasWarehouseAvailability ? '' : 'none';
  if (notice.style.display !== display) notice.style.display = display;
}

function updatePickupTriggerVisibility() {
  const hasData = getSelectedVariantStoreInventory() !== null;
  document.querySelectorAll('.pickup-availability__trigger').forEach(trigger => {
    const display = hasData ? '' : 'none';
    if (trigger.style.display !== display) trigger.style.display = display;
  });
}

function refreshStoreUi() {
  updateShippingNoticeVisibility();
  updatePickupTriggerVisibility();
}

  function fetchInventory(productHandle, variantId) {
    const cacheKey = `${productHandle}__${variantId}`;

    if (inventoryPromise && cachedProductHandle === cacheKey) {
      return inventoryPromise;
    }

    cachedProductHandle = cacheKey;

    // AJOUT 2026-10-16 : /apps/athena/get-products-inventory répond 404 depuis au moins le 15 oct. (proxy de l'app Athena absent).
    // La liste des magasins vient des champs méta (renderFromMetafieldsIfAvailable). On saute l'appel : même résultat qu'avant
    // (un échec donnait déjà des listes vides), sans la requête 404 ni l'erreur dans la console. Pour réactiver : mettre true.
    const ATHENA_INVENTAIRE_ACTIF = false;
    if (!ATHENA_INVENTAIRE_ACTIF) {
      cachedPickupInventory = [];
      cachedVariants = [];
      inventoryPromise = Promise.resolve({ pickUpInventory: [], variants: [] });
      return inventoryPromise;
    }

    inventoryPromise = fetch('/apps/athena/get-products-inventory', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        country: window.ATHENA_COUNTRY || 'CA',
        handles: [productHandle],
        variantId: variantId
      })
    })
    .then(r => r.json())
    .then(data => {
      const inventoryData = data.inventoryData?.find(p => p.productId === productHandle);
      cachedPickupInventory = inventoryData?.pickUpInventory || [];
      cachedVariants = inventoryData?.variants || [];
      updateShippingNoticeVisibility(cachedPickupInventory);
      return { pickUpInventory: cachedPickupInventory, variants: cachedVariants };
    })
    .catch(e => {
      console.error('Inventory fetch error:', e);
      cachedPickupInventory = [];
      cachedVariants = [];
      return { pickUpInventory: [], variants: [] };
    });

    return inventoryPromise;
  }

  document.addEventListener('click', function(e) {
  const trigger = e.target.closest('.pickup-availability__trigger');
  if (!trigger) return;

  const pickupAvailability = trigger.closest('pickup-availability');
const handle = getProductHandle();
const variantId = getSelectedVariantId(pickupAvailability);

if (!handle || !variantId) return;

  hideDrawerContentImmediately();

  if (renderFromMetafieldsIfAvailable(handle)) {
    return;
  }

  if (window.productHasMultipleVariants) {
    const ul = getDrawerList();

    if (ul) {
      ul.innerHTML = `
        <li class="pickup-availability-list-item">
          <svg role="presentation" focusable="false" width="18" height="18" class="text-error icon icon-error" viewBox="0 0 18 18">
            <path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="currentColor"></path>
            <path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>
          </svg>
          <span class="pickup-availability-list-content">
            <span class="pickup-availability-list-text">
              <span class="pickup-availability-list-location">
                Disponibilité non disponible pour cette variante
              </span>
              <span class="pickup-availability-list-status">
                Veuillez contacter le service à la clientèle pour confirmer l’inventaire en magasin.
              </span>
            </span>
          </span>
        </li>
      `;

      showDrawerContent();
    }

    /*const notice = document.getElementById('shipping-notice-48h');
    if (notice) {
      notice.style.display = 'none';
    }*/

    return;
  }

  const cacheKey = `${handle}__${variantId}`;
  if (cachedPickupInventory && cachedProductHandle === cacheKey) {
    renderFromInventory(handle, cachedPickupInventory, cachedVariants);
    return;
  }

  fetchInventory(handle, variantId).then(({ pickUpInventory, variants }) => {
    renderFromInventory(handle, pickUpInventory, variants);
  });
});

document.addEventListener('change', function(e) {
  if (!e.target.matches('input[name="id"]')) return;

  inventoryPromise = null;
  cachedPickupInventory = null;
  cachedVariants = null;

  refreshStoreUi();
});

document.addEventListener('DOMContentLoaded', function() {
  refreshStoreUi();
});

function refillArrivalDateIfEmpty() {
  const dateEl = document.getElementById('shipping-arrival-date');
  if (dateEl && dateEl.textContent.trim() === '') {
    const arrivalDate = addBusinessDays(new Date(), 3);
    dateEl.textContent = formatArrivalDate(arrivalDate);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const productInfoRoot = document.querySelector('.product-info');
  if (!productInfoRoot) return;

  const arrivalDateObserver = new MutationObserver(refreshStoreUi);
  arrivalDateObserver.observe(productInfoRoot, { childList: true, subtree: true });
});

})();